import { Component, OnInit, NgZone } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CMSStorageService } from './core/service/CMS-Storage.service';
import { EncryptedStorageService } from './core/service/EncryptedStorage.service';
import { MasterServiceService } from './core/service/master-service.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { SharedService } from './core/service/shared.service';
import { LoginCoordinatorService } from './core/service/login-coordinator.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, CommonModule, MatButtonModule]
})
export class AppComponent implements OnInit {
    getAllById: any;
    employeeName: any;
    teamLeadName: any;
    employeeId: any;
    getId: any;
    masterRoleDTOList: any;
    roleName: any;
    projectManagerId: any;
    projectManagerName: any;
    modalDisplay = 'none';
    constructor(private cmsStorageService: CMSStorageService, private encryptedStorageService: EncryptedStorageService, private _masterService: MasterServiceService,
        private sharedService: SharedService,
        private _router: Router,
        private _zone: NgZone,
        private loginCoordinator: LoginCoordinatorService
    ) {

    }
    ngOnInit(): void {

        // Only decode token if it exists and is valid
        const authToken = this.encryptedStorageService.getItem('Authorization');
        if (authToken && authToken !== 'null' && authToken !== 'undefined' && authToken.trim() !== '') {
            try {
                this.decodeTokenPayload(authToken);
            } catch (error) {
                console.error('[AppComponent] Error decoding token in ngOnInit:', error);
            }
        }
        this.sharedService.chanagePassword.subscribe((status: boolean) => {
            if (status) {
                this.openModel();
            }
        })

        // Handle SSO login trigger globally (without visiting sign-in component)
        this.loginCoordinator.loginRequest$.subscribe((payload) => {
            try {
                if (payload && payload.oneCoherentIsTrue && payload.data?.accessToken) {
                    const token: string = payload.data.accessToken;
                    this.encryptedStorageService.setItem('Authorization', `Bearer ${token}`);
                    // Navigate to attendance inside Angular zone
                    this._zone.run(() => {
                        this._router.navigate(['/attendance/attendance-punch-in']);
                    });
                }
            } catch { }
        });

    }
    openModel(): void {
        this.modalDisplay = 'block';
    }
    goToPasswordUpdate(): void {
        this._router.navigate(['/password-update']);
        this.modalDisplay = 'none';
    }


    decodeTokenPayload(token: string) {
        try {
            // Remove 'Bearer ' prefix if present
            const cleanToken = token.replace(/^Bearer\s+/i, '').trim();

            const parts = cleanToken.split('.');

            if (parts.length !== 3) {
                console.error('[AppComponent] Invalid token format - expected 3 parts, got:', parts.length);
                return;
            }

            try {
                const decodedPayload = atob(parts[1]);
                let temp = JSON.parse(decodedPayload);

                this.cmsStorageService.setItem('Mail', temp['email']);
                this.cmsStorageService.setItem('Role', temp['role']);
                this.cmsStorageService.setItem('MobileNumber', temp['mobileNumber']);
                this.encryptedStorageService.setItem('UserId', temp['id']);

                this._masterService.getById().subscribe({
                    next: (data) => {
                        this.getAllById = data.data;
                        this.cmsStorageService.setItem("UserId", this.getAllById?.id);
                        this.cmsStorageService.setItem('perjectManagerName', this.getAllById?.projectManagerDetails?.[0]?.fullName || '');
                        this.cmsStorageService.setItem('projectManagerId', this.getAllById?.projectManagerDetails?.[0]?.id || '');
                        this.cmsStorageService.setItem('reportingManagerId', this.getAllById?.teamLeadDetails?.id || '');
                        this.cmsStorageService.setItem('Name', this.getAllById?.employeePersonalDetailsDTO?.employeeName);
                        this.cmsStorageService.setItem('TeamLeadMailId', this.getAllById?.teamLeadDetails?.fullName);
                        this.cmsStorageService.setItem('userId', this.getAllById?.employeeId);
                        this.cmsStorageService.setItem('Id', this.getAllById?.id);
                        this.cmsStorageService.setItem('roleName', this.getAllById?.masterRoleDTOList);
                        this.cmsStorageService.getItem().subscribe((data) => {
                            // Handle item data if needed
                        });
                    },
                    error: (error) => {
                        console.error('[AppComponent] Error fetching user data:', error);
                    }
                });
            } catch (decodeError) {
                console.error('[AppComponent] Error decoding token payload:', decodeError);
            }
        } catch (error) {
            console.error('[AppComponent] Error in decodeTokenPayload:', error);
        }
    }
}
